var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import React from "react";
// @ts-ignore
import SvgIcon from "@mui/material/SvgIcon";
var CloseIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { d: "M12 10.444 7.333 5.778a1.1 1.1 0 1 0-1.555 1.555L10.444 12l-4.666 4.667a1.1 1.1 0 1 0 1.555 1.555L12 13.556l4.667 4.666a1.1 1.1 0 1 0 1.555-1.555L13.556 12l4.666-4.667a1.1 1.1 0 0 0-1.555-1.555L12 10.444Z", fill: "currentColor", "fill-rule": "evenodd", "fill-opacity": ".86" }))); };
export default CloseIcon;
